import { render, staticRenderFns } from "./ProductCtaButtonsMobileMenu.vue?vue&type=template&id=08a255c8&scoped=true&"
import script from "./ProductCtaButtonsMobileMenu.vue?vue&type=script&lang=js&"
export * from "./ProductCtaButtonsMobileMenu.vue?vue&type=script&lang=js&"
import style0 from "./ProductCtaButtonsMobileMenu.vue?vue&type=style&index=0&id=08a255c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a255c8",
  null
  
)

export default component.exports